"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitMeterReadingWrapper = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var analytics_subjects_1 = require("../../analytics-subjects");
var utils_1 = require("../../components/MeterReadingsData/utils");
var MeterReadingsPage_1 = require("../../components/MeterReadingsPage");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_2 = require("../../utils");
var SubmitMeterReading_1 = require("./SubmitMeterReading");
var SubmitMeterReadingV2_1 = require("./SubmitMeterReadingV2");
var SubmitOpeningMeterReading_1 = require("./SubmitOpeningMeterReading");
var utils_3 = require("./utils");
var PageContentMain = function (_a) {
    var _b, _c, _d;
    var selectedFuel = _a.selectedFuel;
    var _e = (0, core_1.useComponents)(), ErrorSection = _e.ErrorSection, Card = _e.Card, Heading1 = _e.Heading1, Notification = _e.Notification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var accountId = (0, ui_tools_1.useAccountContext)().accountId;
    var _f = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _f.readings, supplies = _f.supplies;
    var search = window.location.search;
    var supplyIndex = (0, core_1.getValueFromQueryParams)('supplyIndex', search);
    var supply = (0, utils_2.getSupplyMeterInfo)(supplies, selectedFuel, supplyIndex ? Number(supplyIndex) : undefined);
    var latestActualReading = (0, react_1.useMemo)(function () {
        var _a;
        return (0, utils_1.getLatestManualReading)(readings[selectedFuel], (_a = supply === null || supply === void 0 ? void 0 : supply.mpxn) !== null && _a !== void 0 ? _a : undefined);
    }, [readings, selectedFuel, supply]);
    if (!accountId) {
        return null;
    }
    if (supply && supply.isInOMRWindow) {
        var meterData_1 = (0, utils_3.getMeterReadAnalyticsData)(supply, selectedFuel);
        return !supply.isActive ? (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READINGS_INPUT_SCREEN, properties: (_b = {},
                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                _b.meterData = meterData_1,
                _b) },
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "omrPageTitle" })),
                react_1.default.createElement(Copy, { copyKey: "omrNoActiveSupplies" })))) : (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READINGS_INPUT_SCREEN, properties: (_c = {},
                _c[core_1.INTERNAL_EVENT_FLAG] = true,
                _c.meterData = meterData_1,
                _c) }, !supply.mpxn ? (react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
            react_1.default.createElement(Copy, { copyKey: "noMsn" }))) : (react_1.default.createElement(SubmitOpeningMeterReading_1.SubmitOpeningMeterReading, { accountId: accountId, supply: supply, selectedFuel: selectedFuel, latestOpeningReading: latestActualReading, supplyIndex: supplyIndex ? Number(supplyIndex) : undefined }))));
    }
    if (!supply || !supply.rawMeterType || !supply.msn) {
        return (react_1.default.createElement(ErrorSection, { id: section_ids_1.METER_READING_FORM_ERROR, "data-testid": section_ids_1.METER_READING_FORM_ERROR, errorMetadata: { supply: supply } }));
    }
    var isComplex = (0, utils_2.hasComplexSuppliesContext)(supplies.electricity);
    var meterData = (0, utils_3.getMeterReadAnalyticsData)(supply, selectedFuel);
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READINGS_INPUT_SCREEN, properties: (_d = {},
            _d[core_1.INTERNAL_EVENT_FLAG] = true,
            _d.meterData = meterData,
            _d) }, !supply.mpxn ? (react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
        react_1.default.createElement(Copy, { copyKey: "noMsn" }))) : (react_1.default.createElement(core_1.Feature, { feature: "meterSummary" }, function (enabled) {
        return enabled || isComplex ? (react_1.default.createElement(SubmitMeterReadingV2_1.SubmitMeterReadingV2, { accountId: accountId, supply: supply, latestReading: latestActualReading, selectedFuel: selectedFuel, isComplex: isComplex, supplyIndex: supplyIndex ? Number(supplyIndex) : undefined })) : (react_1.default.createElement(SubmitMeterReading_1.SubmitMeterReading, { accountId: accountId, supply: supply, selectedFuel: selectedFuel, latestActualReading: latestActualReading, supplyIndex: supplyIndex ? Number(supplyIndex) : undefined }));
    }))));
};
exports.SubmitMeterReadingWrapper = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var selectedFuel = _a.selectedFuel;
    var meterReads = core_1.configService.getConfig().meterReads;
    if (meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly) {
        return react_1.default.createElement(kapi_meter_reads_1.KapiSubmitMeterReading, { selectedFuel: selectedFuel });
    }
    return (react_1.default.createElement(MeterReadingsPage_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_INPUT_SCREEN, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b), selectedFuel: selectedFuel },
        react_1.default.createElement(PageContentMain, { selectedFuel: selectedFuel })));
});
